import styled from 'styled-components';
export const CustomTextarea = styled.textarea `
  width: 100%;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  resize: none;
  border: 1px solid
    ${({ theme, hasError }) => hasError
    ? theme.colors.interactive.critical
    : theme.colors.borders.default};
  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
  color: ${({ theme }) => theme.colors.text.default};
  font-size: 1.6rem;
  line-height: 2.4rem;
  font-family: ${({ theme }) => theme.fonts.primaryMedium};
  padding: 1rem 1.8rem;
  ::placeholder {
    color: ${({ theme }) => theme.colors.text.default};
  }
`;
//# sourceMappingURL=styles.js.map